@if (isLoading$ | async) {
  <div
    class="loader-backdrop"
    role="status"
    aria-live="polite"
    aria-label="Loading">
    <div class="loader-content">
      <img
        class="loader-logo"
        src="assets/img/demo/logo.gif"
        alt="Loading" />
      </div>
    </div>
  }

